export const getErrorMessage = (errCode) => {
    const codeMap = {
        100: <>Incorrect email or password</>,
        101: <>This account has been deactivated.</>,
        200: <>This is an FBBC manager account. Please log in at <a href='https://fitbody.coachingoverview.com'>https://fitbody.coachingoverview.com</a></>,
        201: <>This not an FBBC manager account. Please log in at <a href='https://portal.avatarnutrition.com'>https://portal.avatarnutrition.com</a></>
    }

    if(codeMap[errCode])
        return codeMap[errCode]
    else
        return
}